import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { M_InputTextField, M_Button, BufferService, LoadingContext, M_StateActions, M_Header, NavigateContext, M_Select } from 'src/components/M_Components'
import { useDispatch, useSelector } from 'react-redux'
import './settings.css'

export default function ChangeLogCrud({ handleTabClose }) {
  const dispatch = useDispatch()
  const M_State = useSelector((state) => state.StateKeyValue)

  const { t } = useTranslation()
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const passOperation = M_State.filter(obj => obj.key === 'operation')[0]?.value !== null ? M_State.filter(obj => obj.key === 'operation')[0]?.value : 'Error'
  const sessionLine = M_State.filter(obj => obj.key === 'ChangeLogLine')[0]?.value !== null && M_State.filter(obj => obj.key === 'ChangeLogLine')[0]?.value !== undefined ? M_State.filter(obj => obj.key === 'ChangeLogLine')[0]?.value : 'Error'
  const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
  const [operation, setOperation] = useState(passOperation)
  const [passLine, setPassLine] = useState('')
  const [changeLogInfo, setChangeLogInfo] = useState({})
  const [bodyChangeLog, setBodyChangeLog] = useState([])
  const [isFirst, setIsFirst] = useState(true)
  const bufferServiceChangeLog = new BufferService('ChangeLog')
  const sessionKeys = ['passLine', 'operation', 'changeLogInfo', 'bodyChangeLog', 'isFirst']

  const optionsChangeType = [
    { label: t("Added"), value: 0 },
    { label: t("Changed"), value: 1 },
    { label: t("Fixed"), value: 2 },
  ]

  useEffect(() => {
    if (isFirst) {
      dispatch(M_StateActions.removeM_State({ key: 'operation' }))
      dispatch(M_StateActions.removeM_State({ key: 'ChangeLogLine' }))
      setPassLine(sessionLine)
      setIsFirst(false)
    }
    getSessionStorageData(id)
    // eslint-disable-next-line
  }, [])

  const sessionStorageMachine = (id, key, value) => {
    let tempObj = {}
    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
    } else {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (eval(value)) }
    }
    return tempObj
  }

  // eslint-disable-next-line
  useEffect(() => {
    const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    const tempArray = []
    sessionKeys.forEach((key) => {
      tempArray.push(sessionStorageMachine(id, key, key))
    })
    dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
    // eslint-disable-next-line
  }, [id, operation, passLine, changeLogInfo, bodyChangeLog, isFirst])

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true)
    const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
    if (M_StateData) {
      const tempPL = M_StateData.filter(obj => obj.key === `passLine`)[0]?.value
      const tempO = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
      const tempCL = M_StateData.filter(obj => obj.key === `changeLogInfo`)[0]?.value
      const tempBC = M_StateData.filter(obj => obj.key === `bodyChangeLog`)[0]?.value
      const tempIF = M_StateData.filter(obj => obj.key === `isFirst`)[0]?.value
      if (tempPL || tempO || tempCL || tempBC || tempIF) {
        setPassLine(tempPL)
        setOperation(tempO)
        setChangeLogInfo(tempCL)
        setBodyChangeLog(tempBC || [])
        setIsFirst(tempIF)
        ctx.setIsLoad(false)
        return
      }
    }
    getRefresh(sessionLine)
  }

  const getRefresh = (line) => {
    const lineChangeLog = line ? line : passLine

    if (operation === 'Edit') {
      bufferServiceChangeLog.getId(lineChangeLog.Id).then(response => {
        if (response.name === 'AxiosError') {
          handleTabClose(id)
          ctx.toastMessages('error', '', response.message)
          ctx.setIsLoad(false)
          return
        }
        setChangeLogInfo(response)
        setBodyChangeLog(response.Items || [])
      })
    }
    ctx.setIsLoad(false)
  }

  const onSave = () => {
    const tempObj = {
      ...changeLogInfo,
      Items: bodyChangeLog
    }
    ctx.setIsLoad(true)

    if (operation === 'Create' || operation === 'Copy') {
      bufferServiceChangeLog.post(tempObj).then(res => {
        if (res.name === 'AxiosError') {
          ctx.setIsLoad(false)
          ctx.toastMessages('error', res.response?.data?.Errors ? res.response.data.Errors : res.message, '')
          return
        }
        ctx.setIsLoad(false)
        handleTabClose(id)
        ctx.toastMessages('success', '', t('UserCreated'))
        return
      })
    }
    if (operation === 'Edit') {
      bufferServiceChangeLog.update(passLine.Id, tempObj).then(res => {
        if (res.name === 'AxiosError') {
          ctx.setIsLoad(false)
          ctx.toastMessages('error', res.response?.data?.Errors ? res.response.data.Errors : res.message, '')
          return
        }
        ctx.setIsLoad(false)
        handleTabClose(id)
        ctx.toastMessages('success', '', t('UserUpdated'))
        return
      })
    }
  }

  return (
    <>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("RefreshTable")}
              icon={<i className="pi pi-arrow-left iconTable"></i>}
              label={<b>{t("Back")}</b>}
              onClick={() => ctx2.closeTab(id)}
            />
            {operation !== 'View' ?
              <M_Button
                tooltip={t("Save")}
                icon={<i className="pi pi-save iconTable"></i>}
                label={<b>{t("Save")}</b>}
                onClick={() => onSave()}
              />
              : ''}
          </>
        }
      />
      <div className='divGlobalSettings'>
        <div className='formPatchNotes'>
          <div>
            <M_InputTextField
              label={t("Version")}
              value={changeLogInfo.Version || ''}
              onChange={(e) => setChangeLogInfo({ ...changeLogInfo, Version: e.target.value })}
            />
          </div>
          <div>
            <M_InputTextField
              label={t("ReleaseDate")}
              value={changeLogInfo.UpdateDate ? new Date(changeLogInfo.UpdateDate).toISOString().slice(0, 10) : ''}
              type="date"
              onChange={(e) => setChangeLogInfo({ ...changeLogInfo, UpdateDate: e.target.value })}
            />
          </div>
        </div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <M_Button
              tooltip={"AddLine"}
              icon={<i className="pi pi-plus iconTable"></i>}
              label={<b>{t("AddLine")}</b>}
              borderColor={'var(--color-grey)'}
              onClick={() => {
                const newBody = [...bodyChangeLog]
                newBody.push({ Type: 0, Description: '' })
                setBodyChangeLog(newBody)
              }}
            />
          </div>
          <div>
            <div style={{ width: '100%' }}>
              <div className='divHeaderChangeLog'>
                <div style={{ textAlign: 'center' }}>{t("ChangeType")}</div>
                <div>{t("Description")}</div>
                <div></div>
              </div>

              {bodyChangeLog?.map((line, index) => (
                <div className='divRowChangeLog' key={index}>
                  <div>
                    <M_Select
                      label={t('ChangeType')}
                      options={optionsChangeType.map(type => (
                        {
                        label: type.label,
                        value: type.value
                      }))}
                      value={line.Type ?? ''}
                      onChange={e => {
                        const newBody = bodyChangeLog.map((item, i) =>
                          i === index
                            ? { ...item, Type: e.target.value }
                            : item
                        )
                        setBodyChangeLog(newBody)
                      }}
                    />
                  </div>
                  <div>
                    <M_InputTextField
                      label={t("Description")}
                      value={line.Description}
                      onChange={(e) => {
                        const newBody = bodyChangeLog.map((item, i) =>
                          i === index
                            ? { ...item, Description: e.target.value }
                            : item
                        )
                        setBodyChangeLog(newBody)
                      }}

                    />
                  </div>
                  <div>
                    {operation !== 'View' &&
                      <M_Button
                        tooltip={"RemoveLine"}
                        icon={<i className="pi pi-trash iconTable"></i>}
                        onClick={() => {
                          if (bodyChangeLog.length > 1) {
                            const newBody = [...bodyChangeLog]
                            newBody.splice(index, 1)
                            setBodyChangeLog(newBody)
                          } else {
                            ctx.toastMessages('warning', '', 'You must have at least one line!')
                          }
                        }}
                      />
                    }
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}